<!-- splash screen -->
<style>
	.m-loader.m-loader--lg:before {
		width: 130px;
		height: 130px;
		margin-top: -5rem;
		margin-left: -6.2rem;
		border-top-width: 3px;
		border-right-width: 3px;
		border-color: #941a1d;
	}
</style>

<div #splashScreen class="m-splash-screen">
	<div class="m-loader m-loader--success m-loader--lg" style="width: 130px; display: inline-block;">
		<img *ngIf="customerService.settings.name == 'ard'"
			[attr.src]="'assets/app/media/img/logos/turkdefter_icon.png'" style="width: 100px;" alt="Logo">
		<img *ngIf="customerService.settings.name == 'sef'" [attr.src]="'assets/app/media/img/logos/sef.png'"
			style="width: 100px;" alt="Logo">
		<img *ngIf="customerService.settings.name == 'esnaf'" [attr.src]="'assets/app/media/img/logos/esnaf_logo.png'"
			style="width: 100px;" alt="Logo">
		<img *ngIf="customerService.settings.name == 'unidoxstyle'"
			[attr.src]="'assets/app/media/img/logos/unidox_logo.png'" style="width: 100px;" alt="Logo">
	</div>
	<!--here we will have circle progress bar-->
</div>

<router-outlet></router-outlet>